import { QueryClient } from '@tanstack/react-query'

/**
 * Singleton QueryClient shared across the app.
 *
 * Configured to:
 * - Never retry on 401/403 (auth errors) — useAuthMonitor handles those
 *   by refreshing the token and calling invalidateQueries()
 * - Retry up to 2 times for other errors (network blips, 5xx)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        // Don't retry auth errors — token refresh + invalidation handles this
        const status = error?.status ?? error?.statusCode
        if (status === 401 || status === 403) return false
        return failureCount < 2
      },
      staleTime: 30_000,
    },
  },
})
